import { Component, forwardRef, signal } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-supervisors',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    {
      provide: TabComponent,
      useExisting: forwardRef(() => SupervisorsComponent),
    },
  ],
  templateUrl: './supervisors.component.html',
  styleUrl: './supervisors.component.scss',
})
export class SupervisorsComponent extends TabComponent {
  override name: string = this.dictionaryService.get('SupervisorsPerformance');

  onInit() {
    // Don't initialize on component init
  }

  public async main(): Promise<void> { }
}
